import React, { useEffect, useState } from "react";
import { Form, Input, Select } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { loadMasterAju } from "../../../../../redux";
import FormPage from "../../../../../components/pages/FormPage";
const { Option } = Select;

const DefModel = {
    name: "",
    username: "",
    password: "",
    master_aju: "",
    level: 0x01,
    isCreate: true
};

export default () => {
    const dispatch = useDispatch();
    const { masterAjuCache } = useSelector(state => state.apps);
    const [model, setModel] = useState(DefModel);
    const masterAjuOptions = (Array.isArray(masterAjuCache) ? masterAjuCache : []).map(item => ({
        ...item,
        value: `${item?._id || ''}`,
        label: `${item?.no_aju || ''} - ${item?.name || ''}`
    }));
    const refreshMasterAjuCache = () => {
        dispatch(loadMasterAju());
    };

    useEffect(() => {
        dispatch(loadMasterAju());
    }, [dispatch]);

    const normalizeUserPayload = (values) => ({
        ...values,
        master_aju: typeof values?.master_aju === 'object'
            ? values?.master_aju?._id || ''
            : values?.master_aju || ''
    });

    const levels = [
        {
            level: 0x1000,
            value: 'Super Admin'
        },
        {
            level: 0x01,
            value: 'Export',
        },
        {
            level: 0x02,
            value: 'Import'
        },
        {
            level: 0x04,
            value: 'Bea Cukai'
        },
        {
            level: 0x08,
            value: 'PDE',
        },
        // {
        //     level: 0x08,
        //     value: 'PDE'
        // },
    ];
    return (
        <FormPage
            url={"api/v1/users"}
            callbackPath={"/master/users"}
            formValid={false}
            model={model}
            setModel={setModel}
            onEditFormEvent={(values) => normalizeUserPayload(values)}
            onSaveEvent={(values) => normalizeUserPayload(values)}
            title={"Users"}
            wrapperCol={{ span: 8 }}
            labelCol={{ span: 3 }}
        >
            <Form.Item name={"name"} label="name">
                <Input className="input-custom-md" size="default" />
            </Form.Item>
            <Form.Item name={"username"} label="username" rules={[{ required: true }]}>
                <Input className="input-custom-md" size="default" />
            </Form.Item>
            <Form.Item name={"password"} label="password">
                <Input className="input-custom-md" size="default" />
            </Form.Item>
            <Form.Item name={"master_aju"} label="master aju">
                <Select
                    showSearch
                    allowClear
                    options={masterAjuOptions}
                    onFocus={refreshMasterAjuCache}
                    onClick={refreshMasterAjuCache}
                    optionFilterProp="label"
                    filterOption={(inputValue, option) => {
                        const keyword = inputValue.toUpperCase();
                        return option?.label?.toUpperCase().includes(keyword);
                    }}
                />
            </Form.Item>
            <Form.Item name={"level"} label="level">
                <Select>
                    {levels.map((item) => (
                        <Option key={item.level} value={item.level}>
                            {item.value}
                        </Option>
                    ))}
                </Select>
            </Form.Item>
        </FormPage>
    );
}
